"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selection = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Chip = _interopRequireDefault(require("@mui/material/Chip"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Avatar = _interopRequireDefault(require("@mui/material/Avatar"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));
var _colors = require("@mui/material/colors");
var _styles = require("@mui/material/styles");
var Selection = function Selection(_ref) {
  var data = _ref.data,
    title = _ref.title,
    selected = _ref.selected,
    onChange = _ref.onChange,
    id = _ref.id;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var sorted = data.sort(function (a, b) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  });
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "card-for-selection",
    id: id ? id : 'selection'
  }, /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "card-for-selection-title",
    sx: {
      mb: 1,
      pl: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle2"
  }, " ", t(title), " ")), /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    sx: {
      pl: 1,
      pr: 0,
      pb: '8px !important',
      pt: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      rowGap: 1,
      columnGap: 1,
      flexWrap: 'wrap',
      listStyle: 'none',
      p: 0,
      m: 0
    },
    component: "ul"
  }, sorted.map(function (elem) {
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      key: elem.name,
      label: t(elem.name),
      variant: selected === elem.id ? 'filled' : 'outlined',
      onClick: function onClick() {
        return onChange(elem.id);
      }
    });
  }))));
};
exports.Selection = Selection;